import { useState, useEffect } from 'react';

export default function FloatingCallButton() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    // Stop pulsing after 6s
    const timer = setTimeout(() => setPulse(false), 6000);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-[100] flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
    >
      {/* Label tooltip */}
      <div className="bg-gray-900 text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap animate-fade-in">
        Free Estimates — Call Now
      </div>

      {/* Main button */}
      <a
        href="tel:7805178242"
        className="relative group flex items-center gap-3 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white rounded-full pl-4 pr-5 py-3.5 font-bold text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
        aria-label="Call Sierra Kustom Inc."
      >
        {/* Pulse ring */}
        {pulse && (
          <span className="absolute inset-0 rounded-full bg-amber-500 animate-ping opacity-30 pointer-events-none"></span>
        )}
        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
          <i className="ri-phone-fill text-white text-base"></i>
        </div>
        <span className="hidden sm:inline">780-517-8242</span>
        <span className="sm:hidden">Call Us</span>
      </a>
    </div>
  );
}
